const EventEmitter = require('events')
const XMLParser = require('./xml-parser')
const {client: createXMPPClient, xml, jid} = require('@xmpp/client')
const {ulid} = require('ulid')
const {debounce} = require('./functions')
const ChatterService = require('./chatter-service')

var logger = {
  error: (...args) => {console.error(...args)},
  warn: (...args) => {console.warn(...args)},
  info: (...args) => {console.info(...args)},
  debug: (...args) => {console.debug(...args)},
  verbose: (...args) => {console.debug(...args)}
}

const events = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  CHAT_STATE: 'chat-state',
  CHAT_MESSAGE: 'chat-message',
  CHAT_HISTORY: 'chat-history',
  ROSTER: 'roster',
  ERROR: 'error'
}

const CHAT_STATES = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  COMPOSING: 'composing',
  INACTIVE: 'inactive',
  GONE: 'gone'
}

const NS = {
  // HTTPBIND: "http://jabber.org/protocol/httpbind",
  // BOSH: "urn:xmpp:xbosh",
  // CLIENT: "jabber:client",
  // AUTH: "jabber:iq:auth",
  ROSTER: "jabber:iq:roster",
  // PROFILE: "jabber:iq:profile",
  // DISCO_INFO: "http://jabber.org/protocol/disco#info",
  // DISCO_ITEMS: "http://jabber.org/protocol/disco#items",
  // MUC: "http://jabber.org/protocol/muc",
  // SASL: "urn:ietf:params:xml:ns:xmpp-sasl",
  // STREAM: "http://etherx.jabber.org/streams",
  // FRAMING: "urn:ietf:params:xml:ns:xmpp-framing",
  // BIND: "urn:ietf:params:xml:ns:xmpp-bind",
  // SESSION: "urn:ietf:params:xml:ns:xmpp-session",
  // VERSION: "jabber:iq:version",
  // STANZAS: "urn:ietf:params:xml:ns:xmpp-stanzas",
  // XHTML_IM: "http://jabber.org/protocol/xhtml-im",
  // XHTML: "http://www.w3.org/1999/xhtml"
}

const queryCache = {}
const history = {}

const bareJid = function(jid) {
  return jid.split('/')[0]
}

const formatTs = function(ts) {
  if (ts.toString().length > 13) {
    let nTs = ts.toString().substr(0, 13)
    return parseInt(nTs)
  }
  return parseInt(ts)
}

const translateError = function(error) {
  console.error(error)
  if (error['service-unavailable']) {
    // TODO
  }
}

const formatMessage = function(message, chatterInstance) {
  try {
    if (message['body']) {
      let attachment
      if (message['archived']) {
        // Archived messages fetched from history
        var {
          _attributes: { id, to, from, type, xmlns },
          body: {_text},
          archived: {
            _attributes: {
              id: sentAt
            }
          } = {}
        } = message
      } else {
        // messages just received
        var {
          _attributes: { id, to, from, type, xmlns },
          body: {_text}
        } = message
        // TODO
        var sentAt = new Date()
      }

      if (message['attachment']) {
        let {
          attachment: {
            contentType: {_text: contentType},
            url: {_text: url}
          }
        } = message

        attachment = { contentType, url }
      }

      // debugger
      let formattedMessage =  {
        id,
        sent: chatterInstance.bareJid !== bareJid(to),
        to: bareJid(to),
        from: bareJid(from),
        body: _text,
        sentAt: formatTs(sentAt)
      }
      if (attachment && typeof attachment !== 'undefined') {
        formattedMessage.attachment = attachment
      }
      return formattedMessage
    }
  } catch (error) {
    debugger
    logger.error(error)
  }
}

const bindEvents = function(chatterInstance) {
  chatterInstance._xmpp.on('error', err => {
    logger.error('E', err.toString())
    chatterInstance.emit(events.ERROR, err.toString())
  })
  
  chatterInstance._xmpp.on('stanza', async stanza => {
    if (stanza.is('message')) {
      logger.debug('stanza-message', stanza)
    } else {
      logger.debug('stanza', stanza)
    }
  })
  
  chatterInstance._xmpp.on('offline', () => {
    logger.debug('O', 'offline')
    chatterInstance.presence = 'offline'
    chatterInstance.emit(events.OFFLINE, 'offline')
  })
  
  chatterInstance._xmpp.on('online', async address => {
    logger.debug('▶', 'online as', address.toString())
    chatterInstance.presence = 'online'
    // Makes itself available
    await chatterInstance._xmpp.send(xml('presence'))
    chatterInstance.emit(events.ONLINE)
  })

  // Debug
  chatterInstance._xmpp.on('status', status => {
    logger.debug('stat:', 'status', status)
  })
  chatterInstance._xmpp.on('input', inputXml => {
    handleInput(inputXml, chatterInstance)
  })
  chatterInstance._xmpp.on('output', output => {
    logger.debug('out:', output)
  })
}

const handleInput = function(inputXML, chatterInstance) {
  let stanza = XMLParser.toJs(inputXML)
  logger.debug('in, status, jid: ', chatterInstance._xmpp.status, chatterInstance._xmpp.jid)
  logger.debug('in: ', JSON.stringify(stanza))
  const { message, iq, presence } = stanza
  if (message) {
    handleMessage(message, chatterInstance)
  } else if (iq) {
    handleIq(iq, chatterInstance)
  } else if (presence) {
    handlePresence(presence, chatterInstance)
  }
}

const handleMessage = function(message, chatterInstance) {
  const {
    _attributes: {
      id,
      to,
      from,
      type
    },
    result
  } = message

  switch (type) {
    case 'chat':
      let state = Object.keys(message).filter(k => Object.values(CHAT_STATES).indexOf(k) >= 0)[0]
      if (state) {
        let msg = {
          from: bareJid(from),
          state
        }
        chatterInstance.emit(events.CHAT_STATE, msg)
      }

      let { body } = message
      if (body) {
        chatterInstance.emit(events.CHAT_MESSAGE, formatMessage(message, chatterInstance))
      }
      break
    case 'error':
      const {error} = message
      let e = translateError(error)
      chatterInstance.emit(events.ERROR, message)
      break
    default:
      logger.debug(message)
      break
  }
  if (result) {
    /**
     * Message is result from Info Query (iq)
     * */
    const {
      _attributes: {
        queryid
      },
      forwarded: {
        message: historyMessage
      }
    } = result

    let formattedMessage = formatMessage(historyMessage, chatterInstance)
    if (formattedMessage && typeof formattedMessage !== 'undefined') {
      let {
        result: {
          messages = []
        }
      } = queryCache[queryid]

      messages.push(formattedMessage)

      queryCache[queryid].result.messages = messages
    }
  }
}

const handleIq = function(iq, chatterInstance) {
  const {
    _attributes: {
      id,
      to,
      from,
      type
    },
    bind
  } = iq

  if (type === 'result') {
    const {
      query,
      fin
    } = iq

    if (query) {
      let {
        _attributes:  {
          xmlns
        }
      } = query
      if (xmlns === NS.ROSTER) {
        let {item} = query
        if (typeof item  === 'undefined') {
          item = []
        } else if (!Array.isArray(item) && typeof item === 'object') {
          item = [item]
        }
        let roster = item.map(function(it) {
          let { _attributes: { jid } } = it
          return {
            jid,
            bareJid: bareJid(jid)
          }
        })
        chatterInstance.emit(events.ROSTER, roster)
      }
    }
    if (fin) {
      const {
        _attributes: {
          complete,
          queryid
        }
      } = fin

      queryCache[queryid].result.complete = complete === 'true' ? true : false

      if (typeof queryCache[queryid].onFinish === 'function') {
        queryCache[queryid].onFinish(queryCache[queryid])
      }
    }
  }
}

const handlePresence = function(presence, chatterInstance) {
  //
}

class Chatter extends EventEmitter {
  constructor({ chatterService }) {
    super()
    this.chatterService = chatterService
    this.host = chatterService.xmpp.host
    this.websocket = chatterService.xmpp.websocket

    this.presence = 'offline'
    this.name = null
    this.typing = false
    this.jid = null
    this.resource = 'chatter'

    this.debouncedTypingStop = debounce(this.sendTypingStop, 3000)
  }

  async getNewCredentials({} = {}) {
    return this.chatterService.getNewCredentials()
  }

  connect({user, password, host}) {
    this.user = user
    this.password = password
    this.host = host

    this.jid = `${user}@${this.host}/${this.resource}`
    this.bareJid = bareJid(this.jid)

    this._xmpp = createXMPPClient({
      resource: this.resource,
      username: user,
      password,
      domain: this.host,
      service: this.websocket
    })
    bindEvents(this)
    this._xmpp.start()

    return this
  }

  disconnect() {
    this._xmpp.stop()
    return this
  }

  async getRoster({}={}) {
    try {
      const id = ulid()
      const message = xml('iq', {type: 'get', id, from: this.bareJid}, xml('query', {xmlns: NS.ROSTER}))
      await this._xmpp.send(message)
      return message
    } catch (error) {
      throw error
    }
  }

  getHistory({bareJid, pageSize = 10, beforeTimestamp}) {
    if (typeof beforeTimestamp === 'undefined') {
      beforeTimestamp = (new Date()).getTime()
    }
    if (beforeTimestamp.toString().length === 13) {
      beforeTimestamp *= 1000
    }

    const queryid = ulid()
    const msg = xml( 'iq', {xmlns: 'jabber:client', type: 'set', id: ulid()},
      xml('query', {xmlns: 'urn:xmpp:mam:2', queryid},
        xml('x', {xmlns: 'jabber:x:data', type: 'submit'}, 
          xml('field', {var: 'with'},
            xml('value', {}, bareJid)
          )
        ),
        xml('set', {xmlns: 'http://jabber.org/protocol/rsm'},
          [
            xml('max', {}, pageSize),
            xml('before', {}, beforeTimestamp)
          ]
        )
      )
    )

    queryCache[queryid] = {
      result: {},
      onFinish: ({result}) => {
        let {
          complete,
          messages = []
        } = result

        let r = {
          complete,
          messages: messages.sort((a, b) => a.sentAt < b.sentAt)
        }
        this.emit(events.CHAT_HISTORY, r)
      }
    }

    this._xmpp.send(msg)
  }

  async sendText({to, id, text}) {
    try {
      if (typeof text === 'undefined' || text === '') return
      if (typeof id === 'undefined') {
        id = ulid()
      }

      if (this.typing) this.sendTypingStop({to})
      const XMLstring = xml('message', {type: 'chat', id, to, from: this.bareJid}, xml('body', {}, text))
      await this._xmpp.send(XMLstring)

      return {
        id, to, sent: true, body: text
      }
    } catch (error) {
      throw error
    }
  }
  async uploadAndSendAttachment({to, file}) {
    try {
      let res = await this.chatterService.uploadFile(file)
      let {url} = res
      let id = ulid()

      let attachment = {
        contentType: file.type,
        url: url
      }

      if (this.typing) this.sendTypingStop({to})
      const XMLstring = xml('message', {type: 'chat', id, to, from: this.bareJid}, [
        xml('body', {}, url),
        xml('attachment', {}, 
          xml('contentType', {}, attachment.contentType),
          xml('url', {}, attachment.url)
        )
      ])
      await this._xmpp.send(XMLstring)

      return {
        id, to, sent: true, body: file.name, attachment
      }
    } catch (error) {
      throw error
    }
  }
  async sendAttachment({to, attachment: {contentType, url}}) {
    try {
      let id = ulid()

      let attachment = { contentType, url }

      if (this.typing) this.sendTypingStop({to})
      const XMLstring = xml('message', {type: 'chat', id, to, from: this.bareJid}, [
        xml('body', {}, url),
        xml('attachment', {}, 
          xml('contentType', {}, attachment.contentType),
          xml('url', {}, attachment.url)
        )
      ])
      await this._xmpp.send(XMLstring)
      return {
        id, to, sent: true, body: url, attachment
      }
    } catch (error) {
      throw error
    }
  }
  async sendEmail({}) {
    console.error('todo')
  }
  sendTypingStart({to}) {
    if (!this.typing) {
      const message = xml('message', {type: 'chat', id: ulid(), to}, xml('composing'))
      this._xmpp.send(message)
      this.typing = true
    }
    this.debouncedTypingStop({to})
  }
  sendTypingStop({to}) {
    if (this.typing) {
      const message = xml('message', {type: 'chat', id: ulid(), to}, xml('paused'))
      this._xmpp.send(message)
      this.typing = false
    }
  }
}

const chatter = {
  async initialize({url, channelId, token}, {logger: customLogger = null} = {}) {
    try {
      if (customLogger) logger = customLogger
      const chatterService = new ChatterService({url, channelId, token})
      await chatterService.loadServerSettings()
      return new Chatter({chatterService})
    } catch (error) {
      throw error
    }
  },
  events,
  CHAT_STATES
}

if (typeof window !== 'undefined') {
  window.chatter = chatter
}
module.exports = chatter
